import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import medicalInsuranceService from "../../../../api/MedicalInsurance/MedicalInsuranceService";
export default class CreateMedicalInsurance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      medicalInsurance: {
        id: null,
        class: null,
        mapping: null,
        description: null,
        ar_description: null,
        file: null,
      },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  onCreateChange = (e) => {
    let medicalInsurance = this.state.medicalInsurance;
    medicalInsurance[e.target.name] = e.target.value;
    this.setState({ medicalInsurance });
  };

  onButtonClick = () => {
    alert(this.state.medicalInsurance.ar_description);
    medicalInsuranceService.addInsurance({
      class: this.state.medicalInsurance.class,
      mapping: this.state.medicalInsurance.mapping,
      description: this.state.medicalInsurance.description,
      ar_description: this.state.medicalInsurance.ar_description,
      file: this.state.medicalInsurance.file,
    });
    toast.success(`Medical Insurance Created Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.setState({
      medicalInsurance: {
        id: null,
        class: null,
        mapping: null,
        description: null,
        ar_description: null,
        file: null,
      },
    });
    document.getElementById("class").value = "";
    document.getElementById("mapping").value = "";
    document.getElementById("description").value = "";
    document.getElementById("ar_description").value = "";
  };

  onFileSelect = (e) => {
    let medicalInsurance = this.state.medicalInsurance;
    medicalInsurance.file = e.target.files[0];
    this.setState({ medicalInsurance });
  };

  render() {
    return (
      <>
        <h5 className="m-0">Create Medical Insurance</h5>
        <Row form>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Class</label>
              <FormControl
                autoFocus
                type="text"
                name="class"
                id="class"
                onChange={this.onCreateChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Mapping</label>
              <FormControl
                autoFocus
                type="text"
                name="mapping"
                id="mapping"
                onChange={this.onCreateChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Description</label>
              <FormControl
                autoFocus
                type="text"
                name="description"
                id="description"
                onChange={this.onCreateChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="ar_description" id="create-user">
              <label>Arabic Description</label>
              <FormControl
                autoFocus
                type="text"
                name="ar_description"
                id="ar_description"
                onChange={this.onCreateChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <FormControl
                autoFocus
                type="file"
                name="document"
                id="document"
                onChange={this.onFileSelect.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.onButtonClick.bind(this)}
            >
              Create
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
